import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  OrganizationMembershipDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { membersKeys } from "../members.utils"

/**
 * Organization-specific hook for fetching organization members
 * Can only be used in mimber-organization app
 * The organization context is automatically handled by ServerContext
 */
export const useMembers = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<OrganizationMembershipDto[]>, Error>
): UseQueryResult<ResponseDto<OrganizationMembershipDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useMembers")

  const { server } = useServerContext()

  return useQuery({
    queryKey: membersKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<OrganizationMembershipDto[]>
      >(buildQueryString("members", params))
      return response.data
    },
    staleTime: 5 * 60 * 1000, // Consider members data fresh for 5 minutes
    ...options,
  })
}
